import { useMutation } from 'react-query';

import { insightEmailNotification as mutationFn } from 'api/endPoints/insightEmailNotification';

export const useMutationShareInsight = () => {
    return useMutation<any, QueryError, any>((params) => mutationFn(params));
};
